<main class="onb onb--sheet not-found">

  <header class="onb__head">
    <p class="belturo-eyebrow onb__head-eyebrow"><%= _lcs( 'Seite nicht gefunden' ) %></p>
    <h1 class="onb__head-title"><%= _lcs( 'Diese Seite gibt es nicht' ) %></h1>
    <% if ( host ) { %>
      <p class="onb__head-sub not-found__host"><%= host %></p>
    <% } %>
  </header>

  <div class="onb__scroll onb__done">
    <span class="onb-done__icon"><i class="icon icon--compass"></i></span>
    <p class="onb-done__lead"><%= _lcs( 'Unter dieser Adresse ist keine Gäste-App zu finden. Vielleicht hat sich ein Tippfehler eingeschlichen — oder die Unterkunft ist noch nicht freigeschaltet.' ) %></p>
    <p class="onb-done__lead"><%= _lcs( 'Bitte prüfe den Link oder scanne den QR-Code deiner Unterkunft erneut.' ) %></p>
  </div>

</main>
